import { Component, ViewChild,OnInit,ElementRef } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { PositionService} from '../services/position.service';
import { DeviceService } from '../services/device.service';
import { UserService } from '../services/user.service';
import { Message } from 'primeng/primeng';
import * as jsPDF from 'jspdf';
import { AddressService } from '../services/address.service';
import { Table } from 'primeng/components/table/table';
import * as XLSX from 'xlsx';
import { environment} from '../../environments/environment';

@Component({
  selector: 'app-stopped-time-report',
  templateUrl: './stopped-time-report.component.html',
  styleUrls: ['./stopped-time-report.component.css']
})
export class StoppedTimeReportComponent implements OnInit {

  fileName:String;
  displayLocation: boolean=false;
  options: any;
  overlays: any[];
  position:any;
  duration: number;
  positions : any [];
  devices: SelectItem[];
  dateOptions: SelectItem[];
  dateOption: any;
  idDevice: String;
  disabledInitialDate: boolean;
  disabledFinalDate: boolean;
  initialDate: Date;
  finalDate: Date;
  msgs: Message[] = [];
  blockedDocument: boolean = false;
  cols: any[];
  maxDays:number=10;
  stoppedsQuantity:number;
  filters:SelectItem[];
  filter:String;

  @ViewChild('dt') table: Table;
  @ViewChild('content') content: ElementRef;

  constructor(private positionService:PositionService,private deviceService : DeviceService,
    private userService: UserService, private addressService:AddressService) { }

    ngOnInit() {
      this.cols = [
              { field: 'nameDevice', header: 'NOMBRE' },
              { field: 'from', header: 'DESDE' },
              { field: 'to', header: 'HASTA' },
              { field: 'duration', header: 'DURACION (h:m:s)' },
              { field: 'latLng', header: 'POSICION' },
              { field: 'address', header: 'DIRECCION' }
          ];
      this.dateOptions = [
        {label: 'Hoy', value: 'T', icon: 'fa fa-calendar-check-o'},
        {label: 'Ayer', value: 'Y', icon: 'fa fa-calendar-minus-o'},
        {label: 'Ultimos 7 dias', value: '7', icon: 'fa fa-calendar'},
        {label: 'Otro', value: 'O', icon: 'fa fa-calendar-o'}
      ];
      this.filters = [
        {label: 'Encendido', value: 'ignition'},
        {label: 'Velocidad', value: 'speed'}
      ];
      this.filter="ignition";
      this.devices = [];
      this.deviceService.findByUserBranch(this.userService.userLoged.idUser).then(data => {
        let response: any = data;
        response.devices.forEach(item => {
          this.devices.push({label: item.name, value: item.idDevice});
        });
      }).catch(err =>{
        console.log(err);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
      });
      this.duration = 5;
      this.dateOption = '7';
      this.changeDate();
    }

    changeDate(){
      this.disabledInitialDate = true;
      this.disabledFinalDate = true;
      let dateTime = new Date();
      if(this.dateOption == 'T'){
        this.initialDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate(), 0, 0, 0));
        this.finalDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate(), 23, 59, 59));
      }else if(this.dateOption == 'Y'){
        this.initialDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate()- 1, 0, 0, 0));
        this.finalDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate()- 1, 23, 59, 59));
      }else if(this.dateOption == '7'){
        this.initialDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate()- 6, 0, 0, 0));
        this.finalDate = new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate(), 23, 59, 59));
      }else{
        this.disabledInitialDate = false;
        this.disabledFinalDate = false;
      }
    }

    diferenciaEntreFechasEnDias(a:Date, b:Date):number{
      return Math.floor((b.getTime() - a.getTime()) / (1000 * 60 * 60 * 24));
    }

    buscar(){
      if(this.table){
        this.table.first=1;
      }

      this.fileName="ReporteEstacionado_";
      this.devices.forEach(item =>{
        if(item.value == this.idDevice){
          this.fileName = this.fileName+item.label;
        }
      });
      if(this.diferenciaEntreFechasEnDias(this.initialDate,this.finalDate) > this.maxDays){
        this.msgs = [{severity:'error', summary:'ERROR', detail:"El rango de fechas no debe exceder los "+this.maxDays+" dias"}];
        return;
      }
      if(this.initialDate >= this.finalDate){
        this.msgs = [{severity:'error', summary:'ERROR', detail:"La fecha final debe ser superior a la fecha inicial"}];
        return;
      }
      this.blockedDocument = true;
      this.positions = [];
      this.stoppedsQuantity = 0;
      this.positionService.findStoppedTimes(this.idDevice,this.initialDate,this.finalDate,this.duration,this.filter).then(data => {
        let response: any = data;
        response.positions.forEach(item => {
          //if(item.time >= this.duration*1000*60){
            item.latitude = item.latitude.toFixed(6);
            item.longitude = item.longitude.toFixed(6);
            item.latLng = item.latitude+", "+item.longitude
            this.stoppedsQuantity += 1;
            this.positions.push(item);
      //    }
        });
        this.blockedDocument = false;
      }).catch(err =>{
        console.log(err);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
        this.blockedDocument = false;
      });

    }
    showInMap(position:any){
      this.overlays = [];
      this.displayLocation = true;
      let latLng = new google.maps.LatLng(position.latitude, position.longitude);
      this.options = {
        zoom: 13,
        center:latLng
      };
      let marker = new google.maps.Marker({position: latLng});
      this.position = position;
      this.overlays.push(marker);
    }

    hide(){
      this.displayLocation = false;
    }

    getAddress(position:any){
      let latLng = new google.maps.LatLng(position.latitude, position.longitude);

      this.blockedDocument = true;
      this.addressService.findAddressByCoordinates(position).then(data =>{
        let response: any = data;
          if(response.status == 'OK'){
            position.address = response.address;
            this.msgs = [{severity:'info', summary:'INFO', detail:'Dirección obtenida Exitosamente'}];
          }else{
            this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
          }
          this.blockedDocument = false;
      }).catch(err =>{
        console.log(err);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
        this.blockedDocument = false;
      });;
    }

    downloadPDF(){
      let doc = new jsPDF();
      let specialElementHandlers= {
        '#editor':function(element,renderer){
          return true;
        }
      };

    //  let content = this.content.nativeElement;

    /*  doc.fromHTML(content.innerHtml,15,15,{
        'width':190,
        'elementHandlers':specialElementHandlers
      });*/
      doc.text("testing pdf",10,10);

      doc.save('test.pdf');
    }

    exportXLS(){
      let records = [];
      this.positions.forEach(item=>{
        let data = {};
        this.cols.forEach(col => {
          data[col.header] = item[col.field];
        });
        records.push(data);
      });

      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(records);
      const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
      XLSX.writeFile(workbook, this.fileName+".xlsx");
    }

    exportPDF(){
      window.open(environment.reportsEndPoint+"viewStoppedTimeReport?idDevice="+this.idDevice+"&startDate="+this.initialDate.toISOString()+"&endDate="+this.finalDate.toISOString()+"&duration="+this.duration, "_blank");
    }
}



// WEBPACK FOOTER //
// ./src/app/stopped-time-report/stopped-time-report.component.ts